import { Component } from '@angular/core';

@Component({
	selector: 'mb-performance-table-skeleton',
	templateUrl: './performance-table-skeleton.component.html',
	styleUrls: ['./performance-table-skeleton.component.scss']
})
export class PerformanceTableSkeletonComponent {

	public GHOST_ROWS = Array(8).fill(0);

}
